import React, { Dispatch, SetStateAction, useEffect, useState } from "react";

import { Modal } from "./Modal";

import { HeaderModal } from "./Header";
import { Body } from "./Body";
import { FooterModal } from "./Footer";

import closeIcon from "assets/images/close-icon.svg";
import allImgPaths from "assets/images";
import { InputTextField } from "components/InputField";
import CustomSelect from "../CustomSelect";
import CustomCheckBox from "components/CustomCheckBox";
import { pinTaskData } from "services/chat";
import useAppState from "context/useAppState";
import { differenceInDays } from "date-fns";
import { cloneDeep } from "lodash";

const PinModal = ({ draftTitle, setShowPinModal, data, afterSave }: any) => {

  const {
    eventFetchedData
  } = useAppState("eventData");

  const [totalDays, setTotalDays] = useState<any>([]);
  const [isEntireDay, setIsEntireDay] = useState(true);
  const [title, setTitle] = useState<any>(draftTitle || '')
  const [selectedOption, setSelectedOption] = useState('Entire Event')

  useEffect(() => {
    const startDate = eventFetchedData?.start_date;
    const endDate = eventFetchedData?.end_date;
    const numberOfDays = differenceInDays(endDate, startDate) + 1;

    const totalDaysArr: any = []
    Array.from({ length: numberOfDays }, (_, index: any) => {
      totalDaysArr.push(
        { title: `Day ${index + 1}`, isChecked: false }
      )
    })
    setTotalDays(totalDaysArr)

  }, [])

  const save = async () => {
    const dataObj = {
      title: title,
      isEntireDay: isEntireDay,
      totalDays,
      selectedOption
    }

    const payload = {
      isPinned: true,
      pinData: dataObj,
      taskTitle: data?.title || ''
    }

    await pinTaskData(data?.ragId, payload)
    afterSave(true)
    setShowPinModal(false)
  }

  const [showDropdownData, setshowDropdownData] = useState(false);

  const handleDropdownData = () => {
    setshowDropdownData(!showDropdownData);
  }

  const handleCheckboxOne = (isChecked: boolean) => {
    setIsEntireDay(isChecked)
    setSelectedOption('Entire Event')
    if (isChecked) {
      const updatedData = cloneDeep(totalDays.map((item: any) => ({ ...item, isChecked: false })));
      setTotalDays(updatedData)
    }
  }

  const handleCheckboxTwo = (index: number, isChecked: boolean) => {
    const updatedData = cloneDeep(totalDays)
    updatedData[index]['isChecked'] = isChecked;
    setTotalDays(updatedData)
    setSelectedOption(updatedData.filter((item: any) => item.isChecked).map((item: any) => item.title).join(', '))

    const hasChecked = updatedData.some((day: any) => day.isChecked);
    if (hasChecked) {
      setIsEntireDay(false)
    }
  }

  return (
    <>
      <Modal className={"modal-wrapper max-w-[840px]"} isShow={setShowPinModal}>
        <form>
          {/* Modal bg Shade */}

          <HeaderModal title={"test"} isShowHeader={true} className="modal-header py-4 px-4 border-b border-[#EAECF0]">
            <div className="flex items-center justify-between">
              <div className="flex items-center justify-between gap-x-3">
                <img
                  className="cursor-pointer w-12 h-12"
                  src={allImgPaths.pinModalIcon3}
                  alt="pin"
                />
                <h2 className="text-lg text-[#101828] font-interSemiBold leading-none">
                  Pin It
                </h2>
              </div>
              {/* Close Icon */}
              <img
                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                id="modal-toggle"
                src={closeIcon}
                onClick={() => { setShowPinModal(false) }}
                alt="close icon"
              />
            </div>

          </HeaderModal>

          <Body title="" isShowBody={true} className="modal-body px-6 pt-6">
            <div className="flex gap-x-10">
              <div className="w-[320px] border border-[#EAECF0] px-2 py-2 rounded-[10px]">
                <img className="mb-1 h-[190px] object-cover rounded-[10px]" src={allImgPaths.dummyImg} alt="" />
                {/* <h4 className="text-lg text-[#101828] font-interSemiBold pb-2">
                  {data?.isEmailContent ? data?.text?.title : ''}
                  {data?.isRichTextContent ? 'Email Draft' : ''}
                  {!data?.isRichTextContent && !data?.isEmailContent ? data?.title : ''}
                </h4>
                <p className="text-[#475467] text-base line-clamp-6">
                  {data?.isEmailContent ? data?.text?.subject : ''}
                  {data?.isRichTextContent ? 'Email Draft Content' : ''}
                  {!data?.isRichTextContent && !data?.isEmailContent ? data?.description : ''}
                </p> */}
              </div>
              <div className="w-1/2">
                <h4 className="text-lg font-interMedium text-[#475467] pb-6">Tell us a little about this</h4>

                <div className='mb-6'>
                  <p className='text-[#344054] text-sm font-interMedium pb-1.5'>
                    Name
                  </p>
                  <div className='relative pb-2'>
                    <InputTextField
                      className='placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full'
                      name={"title"}
                      placeholder={"Title"}
                      value={title}
                      onChange={(e: any) => { setTitle(e.target.value) }}
                    />
                  </div>
                  <p className="text-sm tex-[#475467]">Give it a custom name for you to associate easily</p>
                </div>

                <div className="mb-6">
                  <p className='text-[#344054] text-sm font-interMedium pb-1.5'>
                    Use for
                  </p>
                  <div className="relative">
                    <InputTextField
                      className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full"
                      name={"name"}
                      placeholder={"Event"}
                      onClick={handleDropdownData}
                      value={selectedOption}
                      onChange={() => { }}
                    />

                    {/* Pin Dropdown */}
                    <div className={`${showDropdownData ? "block" : "hidden"} rounded-lg px-3 py-3 shadow-lg absolute bg-[#fff] z-20 w-full max-h-[250px] overflow-y-auto`}>
                      <div className="bg-[#F9FAFB] rounded px-3 pt-3 last:mb-0">
                        <div className='rfp-custom-checkbox'>
                          <input
                            type='checkbox'
                            name={''}
                            checked={isEntireDay}
                            onChange={(e) => handleCheckboxOne(e.target.checked)}
                            style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                            id="entireDay"
                          />
                          <label
                            htmlFor="entireDay"
                            className={`font-interMedium`}
                          >
                            <span className={`font-interMedium text-[#344054] pl-2`}>Entire Event</span>
                          </label>
                        </div>
                      </div>

                      {
                        totalDays.length > 1 &&
                        <div className="bg-[#F9FAFB] rounded px-3 pt-3 mb-3 last:mb-0">
                          {totalDays.map((item: any, index: any) => (
                            <div className='rfp-custom-checkbox' key={index}>
                              <input
                                type='checkbox'
                                name={''}
                                checked={item.isChecked}
                                onChange={(e) => handleCheckboxTwo(index, e.target.checked)}
                                style={{ width: '16px', height: '18px', cursor: 'pointer' }}
                                id={index}
                              />
                              <label
                                htmlFor={index}
                                className={`font-interMedium`}
                              >
                                <span className={`font-interMedium text-[#344054] pl-2`}>{item.title}</span>
                              </label>
                            </div>
                          ))
                          }

                        </div>
                      }
                      
                    </div>

                  </div>
                  <p className="text-sm tex-[#475467] pt-2">When/how will this be used</p>
                </div>
              </div>
            </div>
          </Body>

          <FooterModal title="" isShowFooter={true} className="modal-footer pt-8 px-6 pb-4">
            <div className="flex justify-end items-center gap-x-2">
              {/* <div className="flex gap-x-2 items-center cursor-pointer">
                <img src={allImgPaths.copyIcon} alt="copy" />
                <span className="text-base text-[#98A2B3] font-interMedium">Copy text</span>
              </div> */}

              <div className="flex items-center gap-x-3 justify-center">
                <button
                  type="button"
                  className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-5 !text-base flex-1"
                  onClick={() => { setShowPinModal(false) }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="!text-base text-white bg-[#1E0AF5] font-interSemiBold rounded-lg  px-5 py-2.5 flex-1"
                  onClick={save}
                >
                  Save
                </button>
              </div>
            </div>
          </FooterModal>
        </form>
      </Modal>
    </>
  );
}

export default PinModal;
